module.exports = __webpack_public_path__ + "static/media/pocket-change-mobiles.468e1e82.jpg";